import { render, staticRenderFns } from "./CustomerUsersList.vue?vue&type=template&id=3057478c&scoped=true&"
import script from "./CustomerUsersList.vue?vue&type=script&lang=js&"
export * from "./CustomerUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057478c",
  null
  
)

export default component.exports